import { render } from "./AddNewNoteType.vue?vue&type=template&id=018496fe"
import script from "./AddNewNoteType.vue?vue&type=script&lang=js"
export * from "./AddNewNoteType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__